import { Grid2, Typography } from '@mui/material';
import React from 'react';

import AiGradient from './AiGradient';
import AiLoader from './AiLoader';




const gradingAssistantSx = { 
  position: 'absolute', 
  zIndex: 1 
};


const gradingAssistantSubHeaderSx = {
  fontFamily: 'Montserrat',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '145%',
  letterSpacing: 0,
  textAlign: 'center',
  color: '#232323'
};

interface LoaderProps {
  title: string;
}



const ResultLoader: React.FC<LoaderProps> = ({ title }) => {
  return (
    <>
      <Grid2 display="flex" alignItems="center" gap={1} justifyContent="center" flexDirection="column" size={12} p={3} height={'100%'}>
        <AiGradient />
        <Grid2 display="flex" alignItems="center" gap={1} justifyContent="center" flexDirection="column" size={12} width={'35%'} sx={gradingAssistantSx}>
          
          <Grid2 mb={6} size={12} display="flex" justifyContent="center" alignItems="center">
            <AiLoader />
          </Grid2>

          <Grid2 mb={2} size={12}>
            <Typography variant="h6" sx={gradingAssistantSubHeaderSx}>
              {title}
            </Typography>
          </Grid2>

        </Grid2>
      </Grid2>
    </>
  );
};

export default ResultLoader;